module.exports = __webpack_public_path__ + "img/default.1efc8753.png";